import React from "react";
import "./Producers.css";

const Producers = () => {
  const producers = [
    "assa_png.png",
    "faac_png.png",
    "dorma_png.png",
    "geze_png.png",
    "record_png.png",
    "assa_png.png",
    "faac_png.png",
    "dorma_png.png",
    "geze_png.png",
    "record_png.png",
    "assa_png.png",
    "faac_png.png",
    "dorma_png.png",
    "geze_png.png",
    "record_png.png",
  ];

  return (
    <section className="producers" id="producenci">
      <h2>PRODUCENCI</h2>
      <div className="slider">
        {/* Podwajamy listę, by pętla była płynna */}
        <div className="slide-track">
          {producers.concat(producers).map((logo, index) => (
            <div className="slide" key={index}>
              {/* 🔽 Tu wstawisz własne loga */}
              <img src={`/images/${logo}`} alt={`Logo ${logo}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Producers;
